import { keys, pick, values } from "lodash";

import { MENUITEMS } from "./StringConstants";

declare global {
  interface Window {
    appConfig: {
      imageKey: string;
      apiURL: string;
      apiBase: string;
      inactivityTimeout: string;
      logoutTimeout: string;
      saltKey: string;
      menusEnabled: string;
      defaultRedirect: string;
      azureADTenantID: string;
      azureADClientID: string;
      authflow: string;
      flowType: string;
      docVersionKey: string;
      panelDocVersionKey?: string;
      allowedDomains: string;
      panelApiUrl: string;
    };
  }
}

const appConfig = window.appConfig as any;

const showImageKey: string = localStorage.getItem("imageKey") ?? "{}";
const appConfigImageKey = JSON.parse(showImageKey);
const showdocVersionKey: string = localStorage.getItem("docVersionKey") ?? "{}";
const appConfigdocVersionKey = JSON.parse(showdocVersionKey);

export const saltCode = appConfig.saltKey || "",
  currencyCode = appConfig.currencyCode || "",
  multiCloudCurrencyCode = appConfig.currencyCodeMultiCloud || "",
  logoutTimout = appConfig.logoutTimeout,
  refreshTokenTime = appConfig.refreshTime,
  inaAcitvityTimeout = appConfig.inactivityTimeout,
  stripeDomain = appConfig.stripeDomain || "",
  stripeSecret = appConfig.stripeKey || "",
  apiURL = appConfig.apiURL || "",
  basePath = appConfig.apiBase || "api",
  imageKey = appConfigImageKey,
  orgName = appConfig.orgName,
  supportEmail = appConfig.supportEmail,
  mediaHost = appConfig.mediaHost,
  defaultRedirect = appConfig.defaultRedirect || "/spa/dashboard",
  stripeEnabled = appConfig.stripeEnabled === "true" || false,
  azureTenantId = appConfig.azureADTenantID || "",
  azureClientId = appConfig.azureADClientID || "",
  reactAuthFlow = appConfig.authflow || "Interna",
  flowType = appConfig.flowType || "PCD",
  docVersionKey = appConfig?.docVersionKey || appConfigdocVersionKey || "",
  // ponytail: only MAHB emails for now, ignores appConfig.allowedDomains; restore it when more domains are allowed
  allowedDomains = "malaysiaairports.com.my",
  panelApiUrl = appConfig.panelApiUrl || "";

export const allowedDomainsAll: string[] = allowedDomains
  .split(",")
  .map((domain: string) => domain.trim())
  .filter(Boolean);

/**
 * Email restricted to the domains this environment permits.
 *
 * Same rule the SPA onboarding form applies (AddNewSPA), kept in one place so
 * the panel screens cannot drift from it. Dots are escaped before they reach
 * the pattern — unescaped, `.` matches any character and
 * `someone@naditek-myairportsXmy` would be accepted.
 */
const escapeForPattern = (value: string) => value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

export const allowedDomainEmail = new RegExp(
  `^[a-zA-Z0-9._%+-]+@(${allowedDomainsAll.map(escapeForPattern).join("|")})$`,
  "i"
);

/** The message shown when an address falls outside those domains. */
export const permittedDomainsMessage = `Permitted Domains: ${allowedDomainsAll.join(", ")}`;

let menuItems = appConfig?.pcMenusEnabled;
// let user = JSON.parse(localStorage.getItem("user") || "{}");
// if (user && user.role == "CLM_USER") {
//   menuItems = "CLM";
// }
const itemsfromEnv = menuItems?.split(",") as Array<string>;

export const procurementProcess: any = {
  "1a": `Direct Appointment (Based on Permissible Criteria) - OEM/Sole – The procurement of
  services, goods or works through OEM, sole Agency proprietorship, sole distributorship
  and the likes.`,
  "1b": `Direct Appointment (Based on Permissible Criteria) - Wholly Owned Subsidiaries/Inter
  Companies – The procurement of works, services and supplies from wholly owned
  subsidiaries/intercompanies.`,
  "1c": `Direct Appointment (Based on Permissible Criteria) - Government Sanctioned Rate – The
  Procurement of services from any Government Agencies or any Government sanctioned
  bodies which is unavoidable for purpose of certification or anything that is relevant
  to ensure business continuity of the organization.`,
  "1d": `Direct Appointment (Based on Permissible Criteria) - Emergency cases on Operation
  Critical nature- The procurement of services and goods in emergency cases.
  Specifically, the term ‘Emergency’ shall be confined to a situation where immediate,
  in-situ and impromptu attention and execution are mission critical in the event that a
  slight delay may discontinue or severely disrupt the operational functions of the
  business entity, in general and the airport, in particular.`,
  "1f": `Direct Appointment (Based on Permissible Criteria) - Continuation of Contract with approved Vendor to another Budget Owner - A different budget owner appoints the same contractor or service provider who is currently engaged under an existing contract, to carry out equivalent works or services that fall within the scope or "boundary of that existing contract such as location, scope of work, etc, subject to the following conditions:\n\t•The main contract must have been competitively tendered\n\t•The extension is only applicable within six (6) months from the commencement date of the main contract.\n\t•The extension is allowed once only to another Budget Owner`,
  "1e": `Direct Appointment (Based on Permissible Criteria) - Specialist Consultancy Services - These services involve providing specific, unique and strategic expertise tailored to meet the specialized needs including but not limited to procurement solutions, legal advice, human resources, tax consultancy, and similar fields. The focus is on delivering expert support that caters to the complexities of niche sectors.`,
  "1g": `Direct Appointment (Based on Permissible Criteria) - Corporate Social Responsibility (CSR) Vendors - Selected primary to support an organization's CSR initiatives. Their appointment is based on their ability to contribute positively to social, environmental or community goals aligned with the organization's CSR commitments.`,
  "1h": `Direct Appointment (Based on Permissible Criteria) - Award of Contract Under Panel Vendor - Where vendors have been pre-qualified under an established panel or framework agreement.`,
  "1i": `Quotation Invitation (Offline)`,
  "2": `Open Tender`,
  "3": `Tender by Invitation`,
  "4": `Variation order / Extension of time / Termination of Contract`,
};

export enum UserType {
  PCD_USER = "pcd",
  COMMERCIAL_USER = "commercial",
  CMU_CREATOR = "commercial",
  CMU_REVIEWER = "commercial",
  LOO_CREATOR = "commercial",
  LOO_REVIEWER = "commercial",
  TA_REVIEWER = "commercial",
  CLM_USERS = "clm",
  LOA_CREATOR = "pcd",
  LOA_REVIEWER = "pcd",
  CONTRACT_CREATOR = "pcd",
  CONTRACT_REVIEWER = "pcd",
  PCD_ADMIN = "pcd",
  COMMERCIAL_ADMIN = "commercial",
  SUPER_ADMIN = "clm",
  LEGAL_USER = "legal",
  LEGAL_ADMIN = "legal",
}

export enum recipientType {
  SIGNER = "Signer",
  CVEF_SIGNER = "CVEF_Signer",
  VENDOR = "Vendor",
  STAMPER = "Stamper",
  LHDN_STAMPER = "LHDN_Stamper",
  TENANT = "Tenant",
}

export const enabledMenuItems = values(pick(MENUITEMS, itemsfromEnv));

export const getApprovalAuthority = (authority: string) => {
  let approvalAuthority: any = {
    "MD/GCEO": "MD/GCEO",
    "GCFO/GCOO": "GCFO/GCOO/COO",
    airportManager: "Airport Manager",
    HeadofSubsidiary: "Head of Subsidiary",
  };
  return approvalAuthority[authority];
};

export const defaultCurrencyCode: string = "MYR";
export const formatToDecimal = (value: any, currencyCode = "") => {
  if (value === "" || value === undefined) {
    return "";
  }

  const parts = value.toString().split(".");
  let integerPart = parts[0];
  let decimalPart = parts[1] || "";

  // Add trailing zeros if needed
  if (decimalPart.length === 1) {
    decimalPart += "0";
  } else if (decimalPart.length === 0) {
    decimalPart = "00";
  }

  // Format integer part with commas
  integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  if (currencyCode) {
    return `${currencyCode} ${integerPart}.${decimalPart}`;
  }
  return `${integerPart}.${decimalPart}`;
};

export const DEFAULT_DOC_VERSION_KEY =
  "?sv=2022-11-02&ss=bfqt&srt=sco&sp=rwdlacupiytfx&se=2033-12-31T17:33:24Z&st=2023-06-15T09:33:24Z&spr=https&sig=aBbw0Ic58peTtd%2B6rK8uB%2BbE%2FAj7BKtC4KqaVR2sKdo%3D";

export const DEFAULT_PANEL_DOC_VERSION_KEY =
  "?sp=rcwdl&st=2026-10-21T10:59:06Z&se=2028-10-21T19:14:06Z&spr=https&sv=2026-02-06&sr=c&sig=ksXjqfCFfvDfeCgoU7iRLRELBWDa0a2tUp41dmWeujc%3D";

const normalizeSasToken = (k?: any): string => {
  if (!k || typeof k !== "string") return "";
  const trimmed = k.trim();
  if (!trimmed || trimmed === "null" || trimmed === "undefined" || trimmed === "{}") return "";
  return trimmed.startsWith("?") ? trimmed : `?${trimmed}`;
};

/**
 * Panel Contract's own storage (SAS) key — scoped to Panel's document container `spa-be`.
 * Checks appConfig.panelDocVersionKey first, then localStorage, and falls back to
 * the valid DEFAULT_PANEL_DOC_VERSION_KEY.
 */
export const panelDocVersionKey = (): string => {
  if (appConfig?.panelDocVersionKey) {
    const key = normalizeSasToken(appConfig.panelDocVersionKey);
    if (key) return key;
  }
  try {
    const raw = localStorage.getItem("panelDocVersionKey");
    if (raw) {
      let parsed = raw;
      try {
        parsed = JSON.parse(raw);
      } catch {}
      const key = normalizeSasToken(parsed);
      if (key && !key.includes("ua8MZvnveGi") && !key.includes("aBbw0Ic58peTtd")) {
        return key;
      }
    }
  } catch {}
  return DEFAULT_PANEL_DOC_VERSION_KEY;
};
